import WebpImage from "@/Components/Front/Blocks/WebpImage";
import FrontText from "@/Components/Front/FrontText";

const WarehouseOtherParam = ({ param, lang }) => {
    let image = '';

    if (param.name.toLowerCase().includes('autostrada') || param.name_en.toLowerCase().includes('highway')) {
        image = '/storage/icons/param-autostrada'
    }
    if (param.name.toLowerCase().includes('lotnisko') || param.name_en.toLowerCase().includes('airport')) {
        image = '/storage/icons/param-lotnisko'
    }
    if (param.name.toLowerCase().includes('transport publiczny') || param.name_en.toLowerCase().includes('public transport')) {
        image = '/storage/icons/param-transport'
    }
    if (param.name.toLowerCase().includes('bocznica kolejowa') || param.name_en.toLowerCase().includes('railway siding')) {
        image = '/storage/icons/param-bocznica'
    }
    if (param.name.toLowerCase().includes('bocznica') || param.name_en.toLowerCase().includes('railway')) {
        image = '/storage/icons/param-bocznica'
    }
    if (param.name.toLowerCase().includes('chłodnia') || param.name_en.toLowerCase().includes('frozen')) {
        image = '/storage/icons/param-chlodnia'
    }
    if (param.name.toLowerCase().includes('crossdock') || param.name_en.toLowerCase().includes('crossdock')) {
        image = '/storage/icons/param-crossdock'
    }
    if (param.name.toLowerCase().includes('lekka produkcja') || param.name_en.toLowerCase().includes('light production')) {
        image = '/storage/icons/param-lekka'
    }
    if (param.name.toLowerCase().includes('monitoring') || param.name_en.toLowerCase().includes('cctv')) {
        image = '/storage/icons/param-monitoring'
    }
    if (param.name.toLowerCase().includes('ochrona') || param.name_en.toLowerCase().includes('ochrona')) {
        image = '/storage/icons/param-ochrona'
    }
    if (param.name.toLowerCase().includes('parking') || param.name_en.toLowerCase().includes('parking')) {
        image = '/storage/icons/param-parking'
    }
    if (param.name.toLowerCase().includes('parking tir') || param.name_en.toLowerCase().includes('parking tir')) {
        image = '/storage/icons/param-parking-tir'
    }
    if (param.name.toLowerCase().includes('stacja kolejowa') || param.name_en.toLowerCase().includes('railway station')) {
        image = '/storage/icons/param-stacja'
    }
    if (param.name.toLowerCase().includes('strefa') || param.name_en.toLowerCase().includes('sez')) {
        image = '/storage/icons/param-strefa'
    }
    if (param.name.toLowerCase().includes('tryskacze') || param.name_en.toLowerCase().includes('sprinkler')) {
        image = '/storage/icons/param-tryskacze'
    }

    const distanceParam = param.pivot.parameter_distance ? param.pivot.parameter_distance : '';

    return (
        <div
            className="flex h-full items-center justify-center px-0 pb-5 rounded-10 gap-y-4 flex-col"
        >
            <div className="bg-D6E3E8 rounded-full flex px-3 py-3 items-center justify-center">
                <WebpImage
                    className="object-contain w-[30px] h-[30px]"
                    sources={[
                        {
                            width: 1,
                            path: image,
                            mime: image.split('.').pop(),
                        },
                    ]}
                    height={41}
                    width={41}
                    alt={lang == 'pl' ? param.name : param.name_en}
                    fallback={image + '.png'}
                    seo={{ width: 20, height: 23 }}
                />
            </div>
            <FrontText textSize={`12/15`} className="font-bold text-new-blue">
                <p className="text-center">{lang == 'pl' ? `${param.name} ${distanceParam}` : `${param.name_en} ${distanceParam}`}</p>
            </FrontText>
        </div>
    )
}

export default WarehouseOtherParam;